export default "__VITE_ASSET__BiZv63U2__"